export default "__VITE_ASSET__Dbwc9t1S__"